import makeStyles from '@material-ui/core/styles/makeStyles';

export const userCardHorizontalPdLg = '40px';
export const userCardHorizontalPdMd = '30px';
export const userCardHorizontalPdSm = '20px';

export const useStyles = makeStyles((theme) => ({
  rootCard: {
    position: 'relative',
    background: 'unset',
    padding: `0 ${userCardHorizontalPdLg} 50px`,
    [theme.breakpoints.down('md')]: {
      padding: `13px ${userCardHorizontalPdMd}`,
    },
    [theme.breakpoints.down('sm')]: {
      padding: `10px ${userCardHorizontalPdSm}`,
    },
  },
  askQuestionBody: {
    maxWidth: '100%',
  },
}));
